module.exports = __webpack_public_path__ + "img/contribution3.9c6cd3ca.png";